"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
exports.default = (function (props) { return (React.createElement("div", { className: 'search-area' },
    React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('admin/system/userManagement/searchFor'), className: "white", icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }), onChange: function (_a) {
            var value = _a.target.value;
            return props.setSearchString(props, value);
        }, value: props.searchString, iconRight: props.searchString === '' ? undefined : (React.createElement(Icon_1.Icon, { className: 'fa-times user-search-clear', onClick: function () { return props.setSearchString(props, ''); } })) }))); });
